"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAuthHandlerInlineBased = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _oauthHandler = require("../oauth-handler");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var OAuthHandlerInlineBased = /*#__PURE__*/function (_OAuthHandler) {
  (0, _inherits2.default)(OAuthHandlerInlineBased, _OAuthHandler);

  var _super = _createSuper(OAuthHandlerInlineBased);

  function OAuthHandlerInlineBased() {
    (0, _classCallCheck2.default)(this, OAuthHandlerInlineBased);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(OAuthHandlerInlineBased, [{
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var token = this.getAccessToken();
      return !!token.accessToken;
    }
  }, {
    key: "displayLoginPage",
    value: function displayLoginPage() {
      // error-catch fix if redirect wants to redirect again. This should never be true
      if (window.location.toString().includes('hello')) {
        throw new Error('Redirect Loop detected');
      }

      window.location = this.provider.getAuthorizeUrl();
      return null;
    }
  }, {
    key: "signOut",
    value: function signOut() {
      // 1. invalidate session for current client
      this.provider.invalidateSession(); // 2. redirect to logout from identity server

      var signOutUrl = this.provider.getSignOutUrl();
      window.location.replace(signOutUrl); // todo show logout spinner

      return null;
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hash;
      return this.provider.getAccessToken(url);
    }
  }, {
    key: "hasValidToken",
    value: function hasValidToken() {
      return this.provider.hasValidToken();
    }
  }, {
    key: "renewToken",
    value: function renewToken() {}
  }]);
  return OAuthHandlerInlineBased;
}(_oauthHandler.OAuthHandler);

exports.OAuthHandlerInlineBased = OAuthHandlerInlineBased;
//# sourceMappingURL=oauth-handler-inline-based.js.map